const updates = [
  {
    date: '2026.07.28',
    title: 'Tor浏览器13.5版本发布：修复高危漏洞，建议立即更新',
    desc: 'Tor Project发布13.5正式版，修复了可能泄露用户真实IP的安全漏洞，所有暗网用户建议在24小时内完成更新。',
    tag: '安全更新',
    tagColor: 'accent',
  },
  {
    date: '2026.07.25',
    title: '暗网市场再现新型钓鱼攻击手法解析',
    desc: '安全研究员发现针对暗网用户的钓鱼攻击，攻击者伪造知名.onion站点诱导用户输入私钥，已有数百人受害。',
    tag: '安全预警',
    tagColor: 'accent',
  },
  {
    date: '2026.07.22',
    title: '吃瓜：某知名暗网论坛数据泄露事件持续发酵',
    desc: '匿名用户投稿爆料某暗网论坛发生大规模数据泄露，涉及数十万用户信息，本站将持续追踪事件进展。',
    tag: '吃瓜爆料',
    tagColor: 'primary',
  },
  {
    date: '2026.07.18',
    title: '暗网深度网搜索引擎Ahmia新增中文索引功能',
    desc: 'Ahmia.fi宣布新增中文暗网站点索引，大幅提升中文用户搜索暗网资源效率，暗网入门门槛进一步降低。',
    tag: '工具更新',
    tagColor: 'secondary',
  },
  {
    date: '2026.07.15',
    title: '匿名投稿通道升级：支持PGP加密附件上传',
    desc: '本站匿名投稿系统已支持PGP加密，稿件传输全程加密，进一步保障投稿人隐私安全与匿名性。',
    tag: '站点公告',
    tagColor: 'secondary',
  },
  {
    date: '2026.07.10',
    title: '暗网入门指南2026版全新上线',
    desc: '重新编写暗网入门指南，覆盖从基础概念到高级安全配置的全部内容，新增移动端暗网访问专题。',
    tag: '指南更新',
    tagColor: 'primary',
  },
  {
    date: '2026.07.05',
    title: '深度网访问：VPN搭配方案横向评测',
    desc: '评测七款主流VPN在暗网访问场景下的表现，从速度、安全性、日志策略等维度给出综合推荐。',
    tag: '评测报告',
    tagColor: 'secondary',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 text-center mb-3">
          最新动态
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10 max-w-lg mx-auto">
          暗网领域最新资讯、安全更新与吃瓜爆料，持续追踪行业动态
        </p>

        <div className="max-w-3xl mx-auto relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-200/60 hidden sm:block"></div>

          <div className="flex flex-col gap-6">
            {updates.map((item, idx) => (
              <div key={idx} className="flex gap-4 sm:gap-6">
                <div className="hidden sm:flex flex-col items-center shrink-0 pt-1">
                  <div className={`w-[10px] h-[10px] rounded-full ${
                    item.tagColor === 'accent' ? 'bg-accent-500' : item.tagColor === 'primary' ? 'bg-primary-500' : 'bg-secondary-500'
                  }`}></div>
                </div>
                <div className="flex-1 bg-background-50 border border-background-200/60 rounded-lg p-5">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-foreground-500 text-xs">{item.date}</span>
                    <span className={`px-2 py-0.5 rounded text-[10px] font-medium ${
                      item.tagColor === 'accent'
                        ? 'bg-accent-500/10 text-accent-400'
                        : item.tagColor === 'primary'
                        ? 'bg-primary-500/10 text-primary-400'
                        : 'bg-secondary-500/10 text-secondary-400'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="font-heading text-sm font-semibold text-foreground-100 mb-1.5">{item.title}</h3>
                  <p className="text-foreground-600 text-xs leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}